export default {
  SET_FAVOURITES: "SET_FAVOURITES",
  REMOVE_FAVOURITE: "REMOVE_FAVOURITE",
  ADD_FAVOURITE: "ADD_FAVOURITE"
};
